import React, { useState, useEffect } from "react";
import moment from "jalali-moment";
import { useSelector } from "../hooks/useTypedSelector";
import { useActions } from "../hooks/useActions";
import HeadingSecondary from "../components/ HeadingSecondary";
import BottomArrow from "../components/svg/BottomArrow";
import Download from "../components/svg/Download";

const SettingHealthProtocol: React.FC<any> = () => {
  const [collapsed, setCollapsed] = useState(true);
  const { fetchHealthProtocols } = useActions();

  const { data, error, loading } = useSelector(
    (state) => state.healthProtocols
  );
  // console.log(data);
  // console.log(error);
  // console.log(loading);

  useEffect(() => {
    if (!data.length) {
      fetchHealthProtocols();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="setting">
      <div className="u-margin-top-medium u-margin-bottom-small-2">
        <HeadingSecondary text="دستورالعمل های بهداشتی" />
      </div>

      <div className="setting__protocols u-margin-bottom-big">
        <div className="setting__protocols__head u-margin-bottom-small-3">
          <h5>دستورالعمل ها</h5>

          <div className="setting__protocols__head__filter">
            <div className="guild__inquiry__filter">
              <div
                className="guild__inquiry__filter__logo u-width-70"
                style={{ left: 0 }}
                onClick={() => {
                  setCollapsed(!collapsed);
                }}
              >
                {/* <Filter /> */}
                <span>مرتب سازی</span>
                <BottomArrow collapsed={collapsed} />
              </div>

              <div className="guild__inquiry__filter__content-holder">
                <div
                  className="guild__inquiry__filter__content-holder__content"
                  style={{
                    left: 0,
                    top: "18px",
                    height: `${!collapsed ? "132px" : "0"}`,
                    opacity: `${!collapsed ? "1" : "0"}`,
                  }}
                >
                  <h6>مرتب سازی بر اساس</h6>
                  <div className="line2"></div>
                  <ul>
                    <li>
                      <input
                        type="radio"
                        name="order"
                        value="DESC"
                        id="new"
                        onChange={(e) => {
                          fetchHealthProtocols(e.target.value);
                          setCollapsed(!collapsed);
                        }}
                      />
                      <label htmlFor="new">جدیدترین</label>
                    </li>
                    <div className="line2"></div>
                    <li>
                      <input
                        type="radio"
                        name="order"
                        value="ASC"
                        id="old"
                        onChange={(e) => {
                          fetchHealthProtocols(e.target.value);
                          setCollapsed(!collapsed);
                        }}
                      />
                      <label htmlFor="old">قدیمی ترین</label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="setting__protocols__body">
          {!loading &&
            !error &&
            data.map((value: any, index: any) => {
              return (
                <React.Fragment key={index}>
                  <div className="protocol-box">
                    <div>
                      <span>{++index}.</span>
                      دستورالعمل
                    </div>
                    <div>
                      {moment(value.lastModifiedDate, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                    </div>
                    <div>
                      <a
                        href={value.fileUrl}
                        className="btn btn--secondary download2 small u-width-80 u-margin-r-auto"
                      >
                        <Download />
                        دانلود
                      </a>
                    </div>
                  </div>
                  {index !== data.length ? (
                    <div className="line3 u-margin-bottom-small-1 u-margin-top-small-1"></div>
                  ) : null}
                </React.Fragment>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default SettingHealthProtocol;
